import React from 'react';
import LocationVehiclePage from './LocationVehiclePage';

const config = {
  city: 'Decatur',
  state: 'TX',
  slug: 'decatur-tx',
  county: 'Wise County',
  driveTime: '10 minutes',
  directions: 'Head south on US-81/287 to FM 1655. Straight shot, no highway hassle.',
  nearbyAreas: [
    'Paradise', 'Bridgeport', 'Alvord', 'Chico', 'Boyd',
    'Rhome', 'Newark', 'Runaway Bay', 'New Fairview', 'Aurora',
    'Greenwood', 'Lake Bridgeport'
  ],
  title: 'Used Cars Decatur TX - Quality Pre-Owned Vehicles Near You',
  h1: 'Affordable Used Cars and Trucks for Decatur Drivers',
  metaDescription: 'Shop quality used cars and trucks near Decatur, TX. 10-minute drive from the Wise County seat. Warranty included on every vehicle. Financing for all credit types. Call (817) 382-2316.',
  ogDescription: 'Decatur residents drive 10 minutes to save thousands on their next car or truck. See what\'s in stock at Paradise-Performance.',
  uniqueContent: {
    heroSubtitle: 'Just 10 minutes south of the Wise County courthouse. Quality vehicles at prices Decatur dealers can\'t match.',
    whyBuyIntro: 'Decatur is the seat of Wise County and the commercial hub for the surrounding rural communities. If you live or work in Decatur, you\'re closer to Paradise-Performance than most people realize. A quick drive down 81/287 puts you in our lot — no big-city traffic, no inflated dealership prices.',
    buyerBenefits: [
      'Prices $2,000-$5,000 below Decatur and DFW lots',
      'No high-pressure sales tactics — family-owned since day one',
      'Transparent pricing with no hidden fees or add-ons',
      'Full-service repair shop on site for after-sale support',
      'Bad credit, no credit — financing options for everyone'
    ],
    contentSections: [
      {
        title: 'Closer Than You Think From Decatur',
        body: 'Most Decatur residents assume they need to drive to Fort Worth or Denton for a good deal on a used car. The truth? Paradise-Performance sits just 10 minutes south. No toll roads. No highway merging. Just a straight shot down 81/287 and FM 1655 to a lot full of inspected vehicles with warranties.'
      },
      {
        title: 'What Decatur Buyers Find Here',
        body: 'We carry European vehicles like BMW, Audi and Volkswagen alongside everyday SUVs for Decatur ISD families. Fuel-efficient cars for the commute into Denton or Fort Worth. Golf carts for the lake houses at Bridgeport. Trailers for hauling. Whatever Decatur life throws at you, we\'ve got a vehicle for it.'
      },
      {
        title: 'Financing Options for Decatur Residents',
        body: 'We work with lenders who understand small-town Texas. Whether you\'re a ranch hand with seasonal income, a first-time buyer straight out of Decatur High, or rebuilding credit after a rough patch — we have financing solutions. Apply online or walk in. Most approvals happen same day.'
      },
      {
        title: 'Service After the Sale',
        body: 'Unlike lot-only dealers in Decatur that sell you a car and wave goodbye, we run a full-service repair shop on site. European car specialist. Diesel certified. General maintenance. Your warranty work gets handled right here — no shipping you to a third-party shop in Fort Worth.'
      }
    ]
  },
  faqs: [
    {
      q: 'How far is Paradise-Performance from Decatur, TX?',
      a: 'About 10 minutes. Head south on US-81/287 and turn onto FM 1655 toward Paradise. No tolls, no highway traffic.'
    },
    {
      q: 'Do you offer financing for Decatur residents?',
      a: 'Yes. We work with multiple lenders and offer financing for all credit situations — good credit, bad credit, no credit and first-time buyers. Most approvals happen the same day.'
    },
    {
      q: 'What types of vehicles do you sell?',
      a: 'Used cars, trucks, SUVs, golf carts and trailers. We specialize in trucks under $20K and also carry European vehicles like BMW, Audi and Mercedes.'
    },
    {
      q: 'Do your vehicles come with a warranty?',
      a: 'Every vehicle sells with a 90-day / 3,000-mile powertrain warranty minimum. Extended options are available. We handle warranty work in our on-site service center.'
    },
    {
      q: 'Can I trade in my current vehicle?',
      a: 'Absolutely. We accept trade-ins from Decatur and all of Wise County. Bring your vehicle in and we\'ll give you a fair market offer on the spot.'
    }
  ]
};

const DecaturTX = () => <LocationVehiclePage config={config} />;
export default DecaturTX;
